import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import {
  M10_MODULE_INFO,
  M10_TOPICS,
  getAllM10Problems
} from '../data/mathExercises/M10_InequalitiesLinearProgramming.js';

const M10InequalitiesLinearProgrammingExercise = ({ onProgress }) => {
  const topics = M10_TOPICS;
  const problems = getAllM10Problems();
  const moduleInfo = M10_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m10-exercise"
    />
  );
};

export default M10InequalitiesLinearProgrammingExercise; 